import { apiCall } from "../../../services/api-service.js";

const get = (endpoint, params) => apiCall("get", endpoint, null, { params });
const post = (endpoint, body) => apiCall("post", endpoint, body);
const put = (endpoint, body) => apiCall("put", endpoint, body);
const del = (endpoint, data = null) => apiCall("delete", endpoint, data);

export const getIndustryListApi = async (params) => {
  try {
    return await get("industry", params);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const submitIndustryListApi = async (body) => {
  try {
    return await post("industry", body);
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const deleteIndustryListApi = async (id) => {
  try {
    return await del(`industry/delete/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getIndustryByIdApi = async (id) => {
  try {
    return await get(`industry/edit/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const updateIndustryListApi = async (id, body) => {
  try {
    return await put(`industry/${id}`, body);
  } catch (err) {
    console.error("Error fetching category:", err);

    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const bulkDeleteIndustryApi = async (payload) => {
  try {
    const data = Array.isArray(payload) ? { id: payload } : payload;
    return await del("industry/bulk_delete", data);
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
